import React from 'react';
import Skeleton from './Skeleton';
import SkeletonGroup from './SkeletonGroup';
import './Skeleton.scss';

const ProfileHeaderSkeleton = ({ removeBackground = false }) => {
  return (
    <div
      className={`profile-header ${
        removeBackground ? 'profile-header--remove-background' : ''
      }`.trim()}
    >
      {/* Avatar skeleton - matches ProfileAvatar structure */}
      <div className='profile-avatar-skeleton'>
        <Skeleton width='120px' height='120px' borderRadius='50%' />
      </div>

      {/* Profile info skeleton - matches profile-header-info structure */}
      <div className='profile-header-info'>
        <SkeletonGroup direction='vertical' spacing='xs'>
          {/* Name skeleton - matches h1 */}
          <Skeleton width='300px' height='28px' borderRadius='4px' />

          {/* Email skeleton - matches profile-email */}
          <div className='width-100'>
            <Skeleton borderRadius='4px' />
          </div>

          {/* Join date skeleton - matches profile-join-date */}
          <div className='width-100'>
            <Skeleton borderRadius='4px' />
          </div>
        </SkeletonGroup>
      </div>

      {/* Action buttons skeleton - matches profile-actions structure */}
      <div className='profile-actions'>
        <Skeleton width='100px' height='36px' borderRadius='6px' />
      </div>
    </div>
  );
};

export default ProfileHeaderSkeleton;
